 (function() {

    'use strict';


    var mimeTypesPreference = 'video/mp4 text/javascript application/x-shockwave-flash video/flv image/gif image/png image/jpeg image/jpg'.split(' ');

    var auxCTP = {};
    (function() {
        for (var i = 0, I = mimeTypesPreference.length, el; i < I; ++i) {
            el = mimeTypesPreference[i];
            auxCTP[el] = i;
        }
    })();

    var ctHeuristic = function(a) {
        var i = auxCTP[ a.item.type ];
        return (i === undefined ? -1 : i);
    };

    var sortByType = function(a, b) {
        return ctHeuristic(a) - ctHeuristic(b);
    };




    var dimsDiff = function(a, b) {
        return Math.abs(a[0] - b[0]) +
               Math.abs(a[1] - b[1]);
    };

    var sortByDimsDiff = function(refDims) {
        var dimsDiff2 = function(c) {
            return dimsDiff(c.item.dims, refDims);
        };
        return function(a, b) {
            return dimsDiff2(a) - dimsDiff2(b);
        };
    };



    SAPO.Project.Video.VAST.handleCompanions = function(compContainers, companions) {
        var diff, cmp, ctn, i, I;

        //setup containers, discard if unavailable
        for (i = compContainers.length - 1; i >= 0; --i) {
            ctn = compContainers[i];
            ctn.container = SAPO.Dom.Selector.select(ctn.container, window.parent.document.documentElement)[0];
            if (!ctn.container) {
                compContainers.splice(i, 1);
            }
        }

        // console.log('compContainers', compContainers);
        // console.log('companions    ', companions);

        // iterate
        for (i = 0, I = compContainers.length; i < I; ++i) {
            if (companions.length === 0) { break; }
            ctn = compContainers[i];
            companions.sort( sortByType               );
            companions.sort( sortByDimsDiff(ctn.dims) );
            // console.log('for ctn sized ' + ctn.dims.join('x'));
            cmp = companions[0];
            diff = dimsDiff(ctn.dims, cmp.item.dims);
            // console.log('companion sized ' + cmp.item.dims.join('x') + ' -> diff: ', diff);
            if (diff > 40) { continue; } // too much difference, don't fill this one
            companions.shift();

            cmp.builder(cmp.item, ctn.container); // instantiate
        }
    };

})();
